// extracted by mini-css-extract-plugin
export default {"container":"SearchForm_container__ndN-I"};